import { render, staticRenderFns } from "./PraticeBannerSection.vue?vue&type=template&id=c8d40098"
import script from "./PraticeBannerSection.vue?vue&type=script&lang=ts"
export * from "./PraticeBannerSection.vue?vue&type=script&lang=ts"
import style0 from "./PraticeBannerSection.vue?vue&type=style&index=0&id=c8d40098&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports